import React, { memo } from 'react';
import Head from 'next/head';

export const LDJSON = memo((props: { data: any }) => (
  <Head>
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          ...props.data,
        }),
      }}
    />
  </Head>
));
